import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Product } from '../../../models/product.model';
import { SKU } from '../../../models/sku.model';

interface IPriceTiers {
  range: string;
  price: string;
  selected: boolean;
}

const TIER_WINDOW_WIDTH = 200;

@Component({
  selector: 'app-pricing-tiers',
  templateUrl: './price-tiers.component.html',
  styleUrls: ['./price-tiers.component.scss'],
  standalone: false,
})
export class PriceTiersComponent implements OnInit, AfterViewInit {
  _quantity = 0;
  _sku: SKU;

  priceTiers: Array<IPriceTiers> = [];

  placementPosition: string;

  @Input() product: Product;

  @Input() showAsTable = false;

  @Input() modal = false;

  @Input() set sku(value: SKU) {
    this._sku = value;
    this.priceTiers = this.computePriceTiers(this.product, this._quantity);
  }

  @Input() set quantity(value: number) {
    this._quantity = value || 0;
    this.priceTiers = this.computePriceTiers(this.product, this._quantity);
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.priceTiers = this.computePriceTiers(this.product, this._quantity);
  }

  ngAfterViewInit(): void {
    this.setDropdownPlacement();
  }

  @HostListener('window:resize')
  // Not private: Angular 21 host bindings access the listener from outside the class.
  onResize() {
    this.setDropdownPlacement();
  }

  private setDropdownPlacement() {
    // check if modal window is open then get size of modal window
    const modalWindow = document.querySelector('app-order-item-modal');
    let windowSize = 0;
    if (modalWindow) {
      windowSize = modalWindow.clientWidth;
    }
    if (!windowSize) {
      windowSize = window.innerWidth;
    }
    const div = this.elementRef.nativeElement.querySelector('.dropdown-toggle');
    if (div) {
      const { x } = div.getBoundingClientRect();
      setTimeout(() => {
        if (this.modal) {
          this.placementPosition = 'bottom-right';
        } else {
          this.placementPosition =
            windowSize < x + TIER_WINDOW_WIDTH ? 'bottom-right' : 'bottom-left';
        }
      });
    }
  }

  private computePriceTiers(
    product: Product,
    quantity: number
  ): Array<IPriceTiers> {
    const result: Array<IPriceTiers> = [];
    const sku = this.currentSKU;
    if (!product || !sku) {
      return result;
    }

    const tiers = sku.getPriceTiers();
    if (tiers.length < 2) {
      return result;
    }

    for (let i = 0; i < tiers.length; i++) {
      let range: string;
      let selected = false;
      const { key, value } = tiers[i];
      if (i === 0) {
        range = `< ${key}`;
        selected = quantity < key;
      } else if (i < tiers.length - 1) {
        const previousTier = tiers[i - 1];
        const from = previousTier.key;
        const to = key - 1;
        if (from !== to) {
          range = from !== to ? `${from} - ${to}` : `${to}`;
          selected = quantity >= from && quantity < to;
        } else {
          range = `${to}`;
          selected = quantity === from;
        }
      } else {
        const previousTier = tiers[i - 1];
        range = `>= ${previousTier.key}`;
        selected = quantity >= previousTier.key;
      }
      result.push({ range, price: `$${value}/${product.getUOM()}`, selected });
    }

    return result;
  }

  get currentSKU(): SKU {
    return this._sku ? this._sku : this.product?.skus?.[0];
  }
}

// purchase opitiosn - icon on photo
